import { useLocation } from "react-router";
import { injectIntl } from "react-intl";
import React, { useEffect, useRef, useState } from "react";
import { Root } from "@/common/Styled/CommonStyled";
import { TitleStyle } from "@/common/Styled/CommonStyled";
import { inject, observer } from "mobx-react";
import PronunciationData from "./PronunciationData"
import { Icon } from '@iconify/react';
import { IconButton } from "@mui/material";
import BottomNavigation from "@/views/CommonComponent/BottomNavigation";
import ShareFileTypeDialog from "@/views/CommonComponent/ShareFileTypeDialog";
import {
  captureElementAndShare,
  isPdfShareSupportedInUserAgent,
} from "@/common/util/shareElementCapture.util";
import { isPronunciation } from "@/nativebridge/JsToNative";
import { NativeToJsBridge, NativeToJsEventName } from "@/nativebridge/NativeToJs";
import {useToast} from "@/components/useToast";
import {DATE_UTIL} from "../../common/util/date.util";


function Pronunciation(props) {
  const [tabValue, setTabValue] = useState("pronunciation");
  const [shareDialogOpen, setShareDialogOpen] = useState(false);
  const {intl, loadingStore, authStore, userStore, pronunciationStore} = props;
  const shareCaptureRef = useRef(null);

  const handleShareIconClick = () => setShareDialogOpen(true);
  const handleShareDialogClose = () => setShareDialogOpen(false);

  const isShareDisabled =
    (pronunciationStore.graphList.length === 0 || (pronunciationStore.graphList.every(data => data.score === 0))) &&
    pronunciationStore.pronunciationList.length === 0;
  const handleShareExport = async (fileType) => {
    setShareDialogOpen(false);

    const el = shareCaptureRef.current;
    if (!el) return;

    const tab = pronunciationStore.selectedTab;
    const start = pronunciationStore.startDatetime?.format
      ? DATE_UTIL.getTimeZoneDate(pronunciationStore.startDatetime, "YYYY.MM.DD")
      : "date";
    const end = pronunciationStore.endDatetime?.format
      ? DATE_UTIL.getTimeZoneDate(pronunciationStore.endDatetime, "YYYY.MM.DD")
      : "";
    const month = pronunciationStore.startDatetime?.format
      ? DATE_UTIL.getTimeZoneDate(pronunciationStore.startDatetime, "YYYY.MM")
      : "month";

    const baseName =
      tab === "weekly"
        ? `pokoro_pronunciation_${start}~${end}`
        : tab === "monthly"
          ? `pokoro_pronunciation_${month}`
          : `pokoro_pronunciation_${start}`;

    pronunciationStore.setIsPronunciationShareLoading(true);
    try {
      await captureElementAndShare(el, fileType, baseName);
    } finally {
      pronunciationStore.setIsPronunciationShareLoading(false);
    }
  };
  const { location } = useLocation();
  const { showDeleteToast } = useToast();

  useEffect(() => {
    isPronunciation(true);
    return () => {
      isPronunciation(false);
    };
  }, []);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [location]);

    useEffect(() => {
        loadingStore.setIsLoading(pronunciationStore.getIsLoading);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pronunciationStore.getIsLoading]);

  useEffect(() => {
    NativeToJsBridge.instance.addEventListener(
        NativeToJsEventName.onSetPushAgree,
        async (event) => {
          const isAgree = event.isAgree;
          console.log("========NativeToJs=========== isAgree=" + isAgree);
            userStore.updateUserPushAgreement(authStore.loginUser.id, isAgree, () => {
                if (!isAgree) {
                    const now = new Date();
                    const formattedDate = `${now.getFullYear()}. ${String(now.getMonth() + 1).padStart(2, '0')}. ${String(now.getDate()).padStart(2, '0')}`;
                    showDeleteToast(
                        <span style={{ whiteSpace: "pre-line" }}>
                            {intl.formatMessage({ id: "Toast_marketing_notification_off" })} {/* 푸시 알림을 거부했습니다. */}
                            &nbsp;{formattedDate}
                        </span>
                    );
                }
            });
        }
    );

    return () => {
      NativeToJsBridge.instance.removeEventListener(
          NativeToJsEventName.onSetPushAgree
      );
    };
  }, []);

  return (
    <Root>
      {tabValue === "pronunciation" && (
        <>
          <TitleStyle>
            <Icon icon="emojione:loudspeaker" />
            {intl.formatMessage({ id: "pronunciation_title" })}
            <IconButton
              onClick={handleShareIconClick}
              disabled={isShareDisabled}
              sx={{ marginLeft: "auto" }}
            >
              <Icon icon="mingcute:share-2-line" fontSize={24} />
            </IconButton>
          </TitleStyle>
          <PronunciationData shareContentRef={shareCaptureRef} />
          <ShareFileTypeDialog
            open={shareDialogOpen}
            onClose={handleShareDialogClose}
            onExport={handleShareExport}
            showPdf={isPdfShareSupportedInUserAgent()}
          />
        </>
      )}
      <BottomNavigation value={tabValue} handleChangeTab={(event, newValue) => setTabValue(newValue)} />
    </Root>
  );
}

export default injectIntl(inject('loadingStore', 'authStore', 'userStore', 'pronunciationStore')(observer(Pronunciation)));